import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER, ErrorHandler, inject, provideEnvironmentInitializer } from '@angular/core';
import { provideRouter, withInMemoryScrolling, Router } from '@angular/router';
import { routes } from './app.routes';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from 'src/app/core/interceptors/auth.interceptor';
import { errorInterceptor } from 'src/app/core/interceptors/error.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import * as Sentry from "@sentry/angular";
import { GoogleAnalyticsService } from 'src/app/core/services/google-analytics.service';
import { ThemeService } from 'src/app/core/services/theme.service';

export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top', anchorScrolling: 'disabled' })),
    provideMomentDateAdapter(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimations(),
    provideEnvironmentInitializer(() => inject(ThemeService)),

    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },

    provideEnvironmentInitializer(() => inject(GoogleAnalyticsService).initialize()),
  ],
};